import React, { useEffect, useRef, useState } from 'react';
import { MetaTags } from 'react-meta-tags';
import {
  Breadcrumbs,
  DashBreadcrumb,
} from '../../components/Common/Breadcrumb';
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Col,
  Container,
  FormGroup,
  Row,
  Spinner,
} from 'reactstrap';
import CouponList from './component/CouponList';
import { useDispatch, useSelector } from 'react-redux';
import ReactDrawer from 'react-drawer';
import { AvField, AvForm } from 'availity-reactstrap-validation';
import toast, { Toaster } from 'react-hot-toast';
import { CouponCreate } from './action/couponAction';

const CsCoupons = () => {
  const dispatch = useDispatch();
  const title = 'Orders';
  const breadcrumbItem = 'Manage CS Coupons';
  const description = 'Manage CS Coupons';
  const [couponData, setCouponData] = useState({});
  const [position, setPosition] = useState();
  const [open, setOpen] = useState(false);
  const [couponAmount, setCouponAmount] = useState(couponData?.amount || 0.0);
  const [isCouponReload, setCouponReload] = useState(false);
  const [isValidPhone, setValidPhone] = useState(null);
  const { country = [] } = useSelector((state) => state.country);
  const [isBtnLoading, setIsBtnLoading] = useState(false);
  let UserRoleID = '';
  if (localStorage.getItem('authUser')) {
    const userObj = JSON.parse(localStorage.getItem('authUser'));
    if (userObj?.role_id !== undefined) {
      UserRoleID = userObj?.role_id;
    }
  }

  const toggleRightDrawer = () => {
    setCouponData({});
    setPosition('right');
    setOpen(!open);
  };
  const onDrawerClose = () => {
    setOpen(false);
  };

  const handleReset = () => {
    formRef.current.reset(); // Reset the form
  };

  const PhoneNumberHandle = (e) => {
    const phoneNumber = e.target.value;
    let NumberRegex = '';
    if (country === 'ae') {
      NumberRegex =
        /^((\+971)|(00971)|0)?(5[0245689]|2[0-9]|3[0-9]|4[0-9]|6[0-9]|7[0-9]|9[0-9])\d{7}$/;
    } else if (country === 'qa') {
      NumberRegex =
        /^(?:\+974|00974|0)?(?:30|31|32|33|34|35|36|37|38|39|40|41|42|43|44|45|46|47|48|49|50|51|52|53|54|55|56|57|58|59|60|61|62|63|64|65|66|67|68|69|70|71|72|73|74|75|76|77|78|79)\d{6}$/;
    } else if (country === 'om') {
      NumberRegex =
        /^(?:\+968|00968|0)?(?:71|72|73|74|75|76|77|78|79|90|91|92|93|94|95|96|97|98|99)\d{6}$/;
    } else if (country === 'bh') {
      NumberRegex =
        /^(?:\+973|00973|0)?(?:30|31|32|33|34|35|36|37|38|39|60|61|62|63|64|65|66|67|68|69)\d{6}$/;
    } else {
      setValidPhone(false);
      return;
    }
    setValidPhone(NumberRegex.test(phoneNumber));
    return;
  };

  const formRef = useRef(null);
  const users = JSON.parse(localStorage?.getItem('authUser'));
  const handleCouponSubmit = async (event, values) => {
    if (country === 'all') {
      toast.error('Please choose a country!!');
    }
    setIsBtnLoading(true);
    const data = { ...values, createdBy: users?.email, country };
    if (isValidPhone) {
      event.preventDefault();
      CouponCreate({
        params: data,
        dispatch,
      });
    } else {
      event.preventDefault();
      setIsBtnLoading(false);
    }
  };

  const { couponCreate = [] } = useSelector((state) => state.coupons);
  useEffect(() => {
    if (couponCreate?.code === 100) {
      setCouponReload(true);
      handleReset();
      toast.success(couponCreate?.message);
      setOpen(false);
      setIsBtnLoading(false);
    } else {
      if (couponCreate?.message) {
        setIsBtnLoading(false);
        toast.error(couponCreate?.message);
      }
    }
  }, [couponCreate, isCouponReload]);
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Mange CS Coupons</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Row>
            <Col xl={6}>
              <DashBreadcrumb title={title} breadcrumbItem={breadcrumbItem} />
            </Col>
            <Col
              xl={6}
              className="text-end"
              style={{ display: 'contents' }}
            ></Col>

            {UserRoleID === '1' || UserRoleID === '28' || UserRoleID === '6' ? (
              <>
                <Col
                  className="textAlignRight mb-4"
                  style={{ marginTop: '20px' }}
                >
                  <button
                    type="submit"
                    className="btn btn-success"
                    onClick={() => {
                      //formRef.current.reset();
                      toggleRightDrawer();
                    }}
                  >
                    Create New Coupon
                    <i className="mdi mdi-plus-circle ms-1"></i>
                  </button>
                </Col>
              </>
            ) : (
              <></>
            )}
          </Row>
          <CouponList
            isCouponReload={isCouponReload}
            setCouponReload={setCouponReload}
            country={country}
            setOpen={setOpen}
            setCouponData={setCouponData}
          />

          <Row>
            <ReactDrawer
              open={open}
              position={position}
              onClose={onDrawerClose}
            >
              <Card>
                <CardHeader>
                  <Row>
                    <Col className="textAlignCenter">
                      <CardTitle>
                        {couponData?.id
                          ? `Update Coupon - ${couponData?.order_reference}`
                          : 'Generate New Coupon'}
                      </CardTitle>
                    </Col>
                    <Col className="textAlignRight">
                      {' '}
                      <button
                        type="button"
                        className="btn-close "
                        onClick={() => {
                          onDrawerClose();
                        }}
                        aria-label="Close"
                      ></button>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  <Row>
                    <Col>
                      <AvForm
                        onValidSubmit={(e, v) => {
                          handleCouponSubmit(e, v);
                        }}
                        ref={formRef}
                      >
                        <FormGroup className="mb-3 productFeedback">
                          <Row>
                            <Col xl={6}>
                              <AvField
                                name="orderRef"
                                label="Order Reference"
                                type="text"
                                value={couponData?.orderRef || ''}
                                required
                              />
                              <AvField
                                name="invId"
                                type="hidden"
                                value={couponData?.id || ''}
                              />
                            </Col>
                            <Col xl={6}>
                              <AvField
                                name="customer_name"
                                label="Customer Name"
                                type="text"
                                value={couponData?.customer_name || ''}
                                required
                              />
                            </Col>
                          </Row>

                          <Row>
                            <Col xl={6}>
                              <AvField
                                name="mobile"
                                label="Mobile No"
                                type="number"
                                value={couponData?.mobile || ''}
                                required
                                onChange={PhoneNumberHandle}
                              />
                              {!isValidPhone && isValidPhone != null ? (
                                <>
                                  <p className="validationError">
                                    Invalid Phone Number
                                  </p>
                                </>
                              ) : (
                                ''
                              )}
                            </Col>
                            <Col xl={6}>
                              <AvField
                                name="email"
                                label="Email Id"
                                type="email"
                                value={couponData?.email || ''}
                                required
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col xl={6}>
                              <AvField
                                name="discountValue"
                                label="Discount Amount"
                                type="number"
                                value={couponData?.discountValue || '0'}
                                minLength="2"
                                min="1"
                                required
                                onChange={(e) => {
                                  setCouponAmount(e.target.value);
                                }}
                              />
                            </Col>
                          </Row>

                          <Row>
                            <Col xl={6}>
                              <AvField
                                name="startsAt"
                                label="Valid From"
                                type="date"
                                value={couponData?.startsAt || ''}
                                required
                                min={new Date().toISOString().split('T')[0]}
                                format="YYYY-MM-DD"
                              />
                            </Col>
                            <Col xl={6}>
                              <AvField
                                name="expiresAt"
                                label="Valid To"
                                type="date"
                                value={couponData?.expiresAt || ''}
                                required
                                min={new Date().toISOString().split('T')[0]}
                                format="YYYY-MM-DD"
                                //To date should be greater than or equal to Valid From date
                                validate={{
                                  validToAfterFrom: (value, ctx) => {
                                    if (!value || !ctx.startsAt) return true;
                                    // Compare as dates
                                    return new Date(value) >=
                                      new Date(ctx.startsAt)
                                      ? true
                                      : 'Valid To date should be greater than or equal to Valid From date';
                                  },
                                }}
                              />
                            </Col>
                          </Row>

                          <Row>
                            <Col xl={12}>
                              <AvField
                                name="remarks"
                                label="Remarks"
                                type="textarea"
                                value={couponData?.remarks || ''}
                                required
                              />
                            </Col>
                          </Row>

                          <AvField
                            type="checkbox"
                            name="isNotifyCustomer"
                            label="Send notification to Customer"
                            checked={true}
                          />
                        </FormGroup>
                        <Row>
                          <Col xl={12}>
                            <div className="productFeedbackCustomerMsg">
                              <p
                                className="productFeedbackCustomer"
                                style={{ alignItems: 'center' }}
                              >
                                <strong>Discount Amount</strong> :{' '}
                                <b style={{ fontSize: 32 }}>
                                  {country === 'ae' ||
                                  couponData?.country === 'ae'
                                    ? 'AED'
                                    : country === 'qa' ||
                                      couponData?.country === 'qa'
                                    ? 'QAR'
                                    : country === 'om' ||
                                      couponData?.country === 'om'
                                    ? 'OMR'
                                    : country === 'bh' ||
                                      couponData?.country === 'bh'
                                    ? 'BHD'
                                    : 'AED'}{' '}
                                  {couponAmount}
                                </b>
                              </p>
                            </div>
                          </Col>
                        </Row>

                        <div className="d-flex mt-2 flex-wrap gap-2">
                          <button
                            type="submit"
                            className="btn btn-secondary"
                            disabled={isBtnLoading}
                          >
                            {isBtnLoading && (
                              <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                              />
                            )}{' '}
                            {couponData?.id
                              ? 'Update Coupon'
                              : 'Generate New Coupon'}
                          </button>{' '}
                          <button
                            type="reset"
                            className="btn"
                            // onClick={handleReset}
                          >
                            Cancel
                          </button>
                        </div>
                      </AvForm>
                    </Col>
                  </Row>

                  <Row></Row>
                </CardBody>
              </Card>
            </ReactDrawer>
          </Row>
        </Container>
      </div>
      <Toaster position="top-right" reverseOrder={false} />
    </React.Fragment>
  );
};
export default CsCoupons;
